import PageWrapper from '../components/basic/PageWrapper';
import LandingSection from '../components/components/HomePage/LandingSection';
import ActivitiesSection from '../components/sections/ActivitiesSection';
import HomePageHelmet from '../components/components/HomePage/HomePageHelmet';
// import ProductsSection from '../components/components/HomePage/TempProductsSection';
import ProductsSection from '../components/components/HomePage/ProductsSection';

const HomePage = () => {
	return (
		<>
			<HomePageHelmet />
			<PageWrapper>
				<LandingSection />
				<ActivitiesSection />
				<ProductsSection />
				{/* <ProductsSection /> */}
			</PageWrapper>
		</>
	);
};

export default HomePage;
